export default function migrate(goal) {
  if (!('subunit' in goal)) {
    goal.subunit = null
  }
  if (!('startAmount' in goal)) {
    goal.startAmount = 0
  }
  return goal
}
